import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Text } from '@react-email/components';
const buttonStyle = {
    backgroundColor: "#0D5AF9",
    borderRadius: "10px",
    textAlign: "center",
    color: "#fff",
    width: '100%',
};
const buttonTextStyle = {
    margin: "12px 16px",
    fontSize: "16px",
    fontWeight: 500
};
export default function BigButton({ children, href }) {
    return (_jsx(Button, { href: href, style: buttonStyle, children: _jsx(Text, { style: buttonTextStyle, children: children }) }));
}
